module.exports = __webpack_public_path__ + "assets/media/s6.a873bc81.mp3";